// extracted by mini-css-extract-plugin
export default {"canvasPopupMenu":"adoOwpwF_GHRgvPq823G","divider":"gj01a_asQGrhUVGqWde9"};